const FALLBACK_DEMO_BOOKING_URL = "https://calendly.com/zindeal/20min";

export const DEMO_BOOKING_URL: string =
  (import.meta.env.VITE_DEMO_BOOKING_URL as string | undefined)?.trim() ||
  FALLBACK_DEMO_BOOKING_URL;

import { useEffect, useState } from "react";
import { trackEvent } from "@/lib/analytics";

type DemoCtaLocation =
  | "landing_hero"
  | "landing_final_cta"
  | "demo_export_gate"
  | "buyout_locked";

const VITE_DEMO_ORG_ID = import.meta.env.VITE_DEMO_ORG_ID as string | undefined;

export function useDemoAvailable(): boolean {
  const [available, setAvailable] = useState<boolean>(Boolean(VITE_DEMO_ORG_ID));
  useEffect(() => {
    if (VITE_DEMO_ORG_ID) return;
    let cancelled = false;
    fetch("/api/demo/status")
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (!cancelled && d?.available) setAvailable(true); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return available;
}

export function trackTryDemoClick(location: DemoCtaLocation): void {
  if (typeof window === "undefined") return;
  const payload = {
    event: "try_live_demo_click",
    location,
    timestamp: new Date().toISOString(),
  };
  try {
    const w = window as DataLayerWindow;
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push(payload);
  } catch { /* ignore */ }
  try {
    window.dispatchEvent(new CustomEvent("try_live_demo_click", { detail: payload }));
  } catch { /* ignore */ }
  trackEvent("try_live_demo_click", { location });
  // Task #429: also record server-side so the owner /admin "Demo
  // conversion" panel can join clicks → signups via the `ah_demo_seen`
  // attribution cookie. Best-effort; failures are silent so the CTA UX
  // never blocks on analytics.
  try {
    void fetch("/api/demo/click", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ location }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* ignore */ }
}

interface DataLayerWindow extends Window {
  dataLayer?: Array<Record<string, unknown>>;
}

export function trackDemoCtaClick(location: DemoCtaLocation): void {
  if (typeof window === "undefined") return;

  const payload = {
    event: "demo_cta_click",
    location,
    url: DEMO_BOOKING_URL,
    timestamp: new Date().toISOString(),
  };

  try {
    const w = window as DataLayerWindow;
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push(payload);
  } catch {
    // ignore
  }

  try {
    window.dispatchEvent(new CustomEvent("demo_cta_click", { detail: payload }));
  } catch {
    // ignore
  }

  trackEvent("demo_cta_click", { location, url: DEMO_BOOKING_URL });
}
